$(document).ready(function() {

    // Open mobile menu
    $("#mobileMenuToggle").on("click", function() { 
        $("#mobileMenuPanel").addClass("open");
    });

    // Close mobile menu
    $("#mobileMenuClose").on("click", function() {
        $("#mobileMenuPanel").removeClass("open");
    });

    // Click outside to close menu
    $(document).on("click", function(e) {
        if (!$(e.target).closest("#mobileMenuPanel, #mobileMenuToggle").length) {
            $("#mobileMenuPanel").removeClass("open");
        }
    });

    // Toggle submenu
    $(".submenu-toggle").on("click", function(e) {
        e.preventDefault(); // Prevent link click
        var submenu = $(this).closest(".mobile-menu-item").find(".mobile-submenu").first();

        if (submenu.is(":visible")) {
            submenu.slideUp(200);
            $(this).text("+"); // Change icon back
        } else {
            submenu.slideDown(200);
            $(this).text("-"); // Change icon to minus
        }
    });

});